/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IBillDetails {
  title: string;
  value: string;
  id: number;
}

interface IBillInput {
  title: string;
  payeeCode: string;
  inputs: any[];
  isRent?: boolean;
}

interface IBillPreview extends IBillInput {
  id: string;
  nickName: string;
}

interface IBillSuccessPayload {
  title: string;
  subTitle: string;
}

interface IRentBillPaymentState {
  isShowBillPaymentModal: boolean;
  activeBillPaymentModal:
    | ''
    | 'billPayInfoModal'
    | 'billSelectModal'
    | 'billAddModal'
    | 'billInputModal'
    | 'billPreviewModal'
    | 'billSuccessModal'
    | 'billDeleteModal'
    | 'rentBillAddModal';
  billPayInfoModalData: { status: string; id: string; details: IBillDetails[] };
  billInputModalData: IBillInput;
  billActionType: 'addBill' | 'payBill' | 'previewBeneficiary' | 'deleteBill' | '';
  billPreviewModalData: IBillPreview;
  billSuccessPayload: IBillSuccessPayload;
  refetchGetBillPayment: boolean;
  refetchGetBeneficiaries: boolean;
}

const initialState: IRentBillPaymentState = {
  isShowBillPaymentModal: false,
  activeBillPaymentModal: '',
  billPayInfoModalData: { status: '', id: '', details: [{ title: '', value: '', id: 0 }] },
  billInputModalData: { title: '', payeeCode: '', inputs: [] },
  billActionType: '',
  billPreviewModalData: { title: '', id: '', nickName: '', payeeCode: '', inputs: [] },
  billSuccessPayload: {
    title: '',
    subTitle: ''
  },
  refetchGetBillPayment: false,
  refetchGetBeneficiaries: false
};

const billPaymentSlice = createSlice({
  name: 'billPayment',
  initialState,
  reducers: {
    setIsShowBillPaymentModal: (state, action: PayloadAction<boolean>) => {
      state.isShowBillPaymentModal = action.payload;
    },
    setActiveBillPaymentModal: (
      state,
      action: PayloadAction<
        | ''
        | 'billPayInfoModal'
        | 'billSelectModal'
        | 'billAddModal'
        | 'billInputModal'
        | 'billPreviewModal'
        | 'billSuccessModal'
        | 'billDeleteModal'
        | 'rentBillAddModal'
      >
    ) => {
      state.activeBillPaymentModal = action.payload;
    },
    setBillPayInfoModalData: (
      state,
      action: PayloadAction<{ status: string; id: string; details: IBillDetails[] }>
    ) => {
      state.billPayInfoModalData = action.payload;
    },
    setBillInputModalData: (state, action: PayloadAction<IBillInput>) => {
      state.billInputModalData = action.payload;
    },
    setBillActionType: (
      state,
      action: PayloadAction<'addBill' | 'payBill' | 'previewBeneficiary' | 'deleteBill' | ''>
    ) => {
      state.billActionType = action.payload;
    },
    setBillPreviewModalData: (state, action: PayloadAction<IBillPreview>) => {
      state.billPreviewModalData = action.payload;
    },
    setBillSuccessPayload: (state, action: PayloadAction<IBillSuccessPayload>) => {
      state.billSuccessPayload = action.payload;
    },
    setRefetchGetBillPayment: (state, action: PayloadAction<boolean>) => {
      state.refetchGetBillPayment = action.payload;
    },
    setRefetchGetBeneficiaries: (state, action: PayloadAction<boolean>) => {
      state.refetchGetBeneficiaries = action.payload;
    }
  }
});

export const {
  setIsShowBillPaymentModal,
  setActiveBillPaymentModal,
  setBillPayInfoModalData,
  setBillInputModalData,
  setBillActionType,
  setBillPreviewModalData,
  setBillSuccessPayload,
  setRefetchGetBillPayment,
  setRefetchGetBeneficiaries
} = billPaymentSlice.actions;

export default billPaymentSlice.reducer;
